import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';
import { Link, SmartInput } from '@beef/legacy-ui-kit';
import { DEFAULT_CAPTCHA_URL } from "./constants";
import { fetchCaptcha } from "./services";
import styles from "./Captcha.pcss";
var cx = classNames.bind(styles);
var Captcha = /*#__PURE__*/function (_Component) {
  function Captcha(props) {
    var _this;
    _classCallCheck(this, Captcha);
    _this = _callSuper(this, Captcha, [props]);
    _defineProperty(_this, "handleChange", function (value) {
      var onChange = _this.props.onChange;
      var captchaKey = _this.state.captchaKey;
      _this.setState({
        captcha: value
      });
      if (onChange) onChange(captchaKey ? {
        captcha: value,
        captchaKey: captchaKey
      } : value);
    });
    _this.state = {
      pic: null,
      captcha: '',
      captchaKey: ''
    };
    _this.updateCaptcha = _this.updateCaptcha.bind(_this);
    _this.setValue = _this.setValue.bind(_this);
    return _this;
  }
  _inherits(Captcha, _Component);
  return _createClass(Captcha, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var onMount = this.props.onMount;
      this.updateCaptcha();
      if (onMount) onMount(this);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var refreshCaptcha = this.props.refreshCaptcha;
      if (refreshCaptcha && refreshCaptcha !== prevProps.refreshCaptcha) {
        this.updateCaptcha();
        this.setValue('');
      }
    }

    // eslint-disable-next-line react/no-unused-class-component-methods
  }, {
    key: "getValue",
    value: function getValue() {
      return this.state.captcha;
    }
  }, {
    key: "setValue",
    value: function setValue(captcha) {
      this.setState({
        captcha: captcha
      });
    }
  }, {
    key: "updateCaptcha",
    value: function () {
      var _updateCaptcha = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var _this$props, captchaUrl, captchaKey, width, height, captchaRequestUrl, newCaptcha;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _this$props = this.props, captchaUrl = _this$props.captchaUrl, captchaKey = _this$props.captchaKey, width = _this$props.width, height = _this$props.height;
              captchaRequestUrl = "/".concat(captchaUrl, "?w=").concat(width, "&h=").concat(height, "&key=").concat(captchaKey, "&r=").concat(Math.random());
              _context.next = 4;
              return fetchCaptcha(captchaRequestUrl);
            case 4:
              newCaptcha = _context.sent;
              this.setState(newCaptcha);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function updateCaptcha() {
        return _updateCaptcha.apply(this, arguments);
      }
      return updateCaptcha;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$props2 = this.props,
        name = _this$props2.name,
        onBlur = _this$props2.onBlur,
        onFocus = _this$props2.onFocus,
        status = _this$props2.status,
        msg = _this$props2.msg,
        inputId = _this$props2.inputId,
        size = _this$props2.size,
        forceTouch = _this$props2.forceTouch,
        disabled = _this$props2.disabled,
        inputClass = _this$props2.inputClass;
      var _this$state = this.state,
        pic = _this$state.pic,
        captcha = _this$state.captcha;
      return /*#__PURE__*/React.createElement("div", {
        className: cx('captcha'),
        "data-t-id": "components-FeedbackCaptcha"
      }, /*#__PURE__*/React.createElement(SmartInput, {
        captcha: pic,
        disabled: disabled,
        forceTouch: forceTouch,
        inputId: inputId,
        mask: "_____",
        msg: msg,
        name: name,
        onBlur: onBlur,
        onChange: this.handleChange,
        onFocus: onFocus
        // eslint-disable-next-line react/no-unused-class-component-methods,no-return-assign
        ,
        ref: function ref(e) {
          return _this2.inputElement = e;
        },
        size: size,
        status: status,
        textInputClass: inputClass,
        value: captcha
      }), /*#__PURE__*/React.createElement("div", {
        className: cx('reset')
      }, /*#__PURE__*/React.createElement(Link, {
        onClick: this.updateCaptcha
      }, "\u041E\u0431\u043D\u043E\u0432\u0438\u0442\u044C \u0441\u0438\u043C\u0432\u043E\u043B\u044B")));
    }
  }]);
}(Component);
Captcha.defaultProps = {
  width: 123,
  height: 39,
  refreshCaptcha: false,
  captchaUrl: DEFAULT_CAPTCHA_URL
};
Captcha.propTypes = process.env.NODE_ENV !== "production" ? {
  name: PropTypes.string,
  captchaKey: PropTypes.string,
  inputClass: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  onBlur: PropTypes.func,
  onFocus: PropTypes.func,
  status: PropTypes.string,
  msg: PropTypes.string,
  onMount: PropTypes.func,
  inputId: PropTypes.string,
  onChange: PropTypes.func,
  size: PropTypes.string,
  forceTouch: PropTypes.bool,
  disabled: PropTypes.bool,
  refreshCaptcha: PropTypes.bool,
  captchaUrl: PropTypes.string
} : {};
export default Captcha;